<template>
  <div id="schedule" class="inner _open Schedule">
    <h2 class="Head Head--cl01 Head--mg_md">
      <span
        class="Head__main Head--md"
      >
        Class schedule
      </span>
      <br>
      <span class="Head__main_jp">
        クラススケジュール
      </span>
    </h2>
    <div class="Schedule__scroll_tx">
      スライドして他の日程もご確認いただけます
    </div>
    <div id="scrollbarTop" class="Schedule__scrollbar-top">
      <div id="scrollbarThumb" class="Schedule__scrollbar-thumb" />
    </div>
    <div class="Schedule__area">
      <!-- <button id="btn_l" class="Schedule__btn_arrow Schedule__btn_arrow--l" @click="lastDateOfWeek" /> -->
      <div class="Schedule__columns Schedule__time">
        <div class="Schedule__class Schedule__day Schedule__class_time _bder-none">
          <div class="Schedule__day_box" />
        </div>
        <div v-for="(time,key) of timeSlots" :key="key" class="Schedule__class Schedule__class_time">
          <div class="Schedule__class_box Schedule__class_time_box">
            <div class="Schedule__class_time_top">
              {{ time }}
            </div>
          </div>
        </div>
      </div>
      <!-- class -->
      <div
        id="wrap"
        class="Schedule__inner"
      >
        <div
          v-for="(day,key) of curWeek"
          :key="key"
          class="Schedule__columns"
        >
          <div class="Schedule__class Schedule__day">
            <div class="Schedule__day_box">
              <div class="Schedule__day_top">
                {{ handleHeader(day) }}
              </div>
              <div>{{ getDayOfWeek(day) }}</div>
            </div>
          </div>
          <div
            v-for="(time,slot) of timeSlots"
            :key="slot"
            class="Schedule__class"
          >
            <div
              v-if="listSchedule[handleDateToDay(day)] && listSchedule[handleDateToDay(day)][time]"
              :class="`Schedule__class_box Schedule__class_name
                      Schedule__class_box--${(listSchedule[handleDateToDay(day)][time]['is_favorite_instructor']||listSchedule[handleDateToDay(day)][time]['is_favorite_category']) ? 'like' : ''}
                      Schedule__class_box--${listSchedule[handleDateToDay(day)][time]['is_recorded'] ? 'recorded' : ''}`"
              :style="`background-color: ${listSchedule[handleDateToDay(day)][time]['master_program_category']['c_background_color']};`"
              @click="openModalSchedule(listSchedule[handleDateToDay(day)][time]['id'])"
            >
              <div class="Schedule__class_icon_time">
                <span class="Schedule__class_icon_time--icon">
                  <img
                    :src="listSchedule[handleDateToDay(day)][time]['master_program_category']['c_icon_url']"
                    alt=""
                  >
                </span>
                {{ listSchedule[handleDateToDay(day)][time]['time'] }}分
              </div>
              <div class="Schedule__class_name_top">
                {{ listSchedule[handleDateToDay(day)][time]['class'] }}
              </div>
              <div class="Schedule__class_name_bottom">
                <span class="Schedule__class_name_bottom--icon">
                  <img
                    :src="showAvatar(listSchedule[handleDateToDay(day)][time]['master_instructor'])"
                    alt=""
                  >
                </span>
                {{ listSchedule[handleDateToDay(day)][time]['master_instructor']['name'] }}
              </div>
            </div>
            <div
              v-else
              class="Schedule__class_box Schedule__class_name Schedule__class_box--empty"
            />
          </div>
        </div>
      </div>
      <div class="Schedule__area_faded" />
      <!-- <button id="btn_r" class="Schedule__btn_arrow Schedule__btn_arrow--r" @click="nextDateOfWeek" /> -->
    </div>
  </div>
</template>

<script>
import { convertNumToTime, convertTimeToDetail } from '@/helpers'
import moment from 'moment'
import ScheduleToDay from '@/services/scheduleService'
import { convertAvatar } from '@/helpers'

export default {
  name: 'ScheduleCalendar',
  data() {
    return {
      timeSlots: [],
      curWeek: [],
      listSchedule: {},
      mondayCurrent: '',
      listScheduleAll: [],
      halfPartDayMillisecond: 12 * 60 * 60 * 1000,
      oneDayMillisecond: 24 * 60 * 60 * 1000,
      lastDay: null
    }
  },
  created() {
    window.addEventListener('resize', this.updateScrollBarThumb)
  },
  mounted() {
    this.currentWeek()
    const listElm = document.querySelector('#wrap')
    const topScrollbar = document.getElementById('scrollbarTop')

    topScrollbar.addEventListener('scroll', e => {
      listElm.scrollLeft = topScrollbar.scrollLeft
    })
    listElm.addEventListener('scroll', e => {
      topScrollbar.scrollLeft = listElm.scrollLeft
      if (listElm.scrollLeft + listElm.clientWidth >= listElm.scrollWidth) {
        this.appendSchedule()
      }
    })
    // const observer = new MutationObserver(this.updateScrollbarThumb)
    // observer.observe(listElm, { childList: true, subtree: true })
  },
  methods: {
    updateScrollBarThumb() {
      const listElm = document.getElementById('wrap')
      const scrollbarThumb = document.getElementById('scrollbarThumb')
      scrollbarThumb.style.width = listElm.scrollWidth + 'px'
    },
    getDayOfWeek(date) {
      return moment(date).locale('ja').format('ddd').toString().toLowerCase()
    },
    openModalSchedule(scheduleId) {
      this.$store.dispatch('modal/openModalSchedule', { scheduleId })
    },
    showTime(time) {
      return convertNumToTime(time)
    },
    showTimeDetail(time) {
      return convertTimeToDetail(time)
    },
    getTimeSlots(time) {
      return [...new Set(time)]
    },
    currentWeek() {
      const today = moment()._d
      const currentWeek = []
      currentWeek[0] = new Date(today.setDate(today.getDate()))
      for (let i = 1; i < 7; i++) {
        currentWeek[i] = new Date(today.setDate(today.getDate() + 1))
      }
      this.lastDay = today
      this.curWeek = currentWeek
      this.getListSchedule()
    },
    handleDateToDay(date) {
      return moment(date).format('YYYYMMDD')
    },
    handleHeader(date) {
      const day = moment(date).format('DD')
      if (day === '01') {
        return moment(date).format('M/D')
      }
      return moment(date).format('DD')
    },
    async getListSchedule() {
      const queryParams = {
        params: {
          first: this.curWeek[0],
          last: this.curWeek[6]
        }
      }
      const response = await ScheduleToDay.index(queryParams)
      response.data.forEach(element => {
        element.date = moment(element.date).local()
        element.learning_time = element.date.format('HH:mm')
      })
      this.listScheduleAll = response.data
      this.handleSchedule()
    },
    handleSchedule() {
      const monday = moment(this.curWeek[0]).format('YYYY-MM-DD')
      const sunday = moment(this.curWeek[this.curWeek.length - 1]).format('YYYY-MM-DD')
      const dayMin = Date.parse(monday) - this.halfPartDayMillisecond
      const dayMax = Date.parse(sunday) + this.oneDayMillisecond
      const result = {}
      const timeClass = []
      this.listScheduleAll.forEach(item => {
        const format_time_ios = moment(item.date).format('YYYY/MM/DD HH:mm:ss')
        const time = item.learning_time
        timeClass.push(time)
        if (!result[this.handleDateToDay(item.date)]) {
          result[this.handleDateToDay(item.date)] = {}
        }
        if (Date.parse(format_time_ios) >= dayMin &&
            Date.parse(format_time_ios) <= dayMax
        ) {
          result[this.handleDateToDay(item.date)][item.learning_time] = item
        } else {
          delete result[this.handleDateToDay(item.date)]
        }
      })
      this.timeSlots = this.getTimeSlots(timeClass.sort(function(a, b) { return a.localeCompare(b) }))
      this.listSchedule = result
      this.reloadComponent()
    },
    nextDateOfWeek() {
      const firstDayCur = moment(this.curWeek[0]).format('YYYY-MM-DD')
      const firstDaySec = Date.parse(firstDayCur)
      let nextday = 0
      const nextToWeek = []
      for (let i = 0; i < 7; i++) {
        nextToWeek[i] = new Date(firstDaySec + nextday + 7 * this.oneDayMillisecond)
        nextday += this.oneDayMillisecond
      }
      this.curWeek = nextToWeek
      this.getListSchedule()
    },
    lastDateOfWeek() {
      const firstDayCur = moment(this.curWeek[0]).format('YYYY-MM-DD')
      const firstDaySec = Date.parse(firstDayCur)
      let lastDay = 0
      const lastWeek = []
      for (let i = 0; i < 7; i++) {
        lastWeek[i] = new Date(firstDaySec + lastDay - 7 * this.oneDayMillisecond)
        lastDay += this.oneDayMillisecond
      }
      this.curWeek = lastWeek
      this.getListSchedule()
    },
    reloadComponent() {
      this.$emit('reload')
    },
    async appendSchedule() {
      const nextWeek = []
      for (let i = 1; i <= 7; i++) {
        nextWeek.push(new Date(this.lastDay.getTime() + i * this.oneDayMillisecond))
      }
      this.curWeek = this.curWeek.concat(nextWeek)
      this.lastDay = nextWeek.pop()
      const queryParams = {
        params: {
          first: nextWeek[0],
          last: this.lastDay
        }
      }
      const response = await ScheduleToDay.index(queryParams)
      this.listScheduleAll.push(...response.data)
      this.handleSchedule()
      this.updateScrollBarThumb()
    },
    showAvatar(instructor) {
      let url = null
      if (instructor) {
        url = instructor.image_url
      }
      return convertAvatar(url)
    }
  }
}
</script>
